import React from 'react';
import ReactPlayer from 'react-player';
import classNames from "classnames";

export class VideoPlayer extends React.Component {
	static defaultProps = {
		playable: true
	};

	state = {
		isStarted: false,
		isPaused: false
	};

	constructor(props) {
		super(props);
		this.state.isStarted = props.autoplay || false;
	}

	pause() {
		this.setState({isPaused: true});
		console.log('pause called');
	}

	unpause() {
		this.setState({isPaused: false});
		console.log('unpause called');
	}

	render() {
		let isPlaying = this.props.playable && this.state.isStarted && !this.state.isPaused;

		return (
			<div className={classNames('video-player-wrapper', {'square': this.props.square || false}, {paused: this.state.isPaused}, {isPlaying: isPlaying})}>
				<div
					className={'video-player'}
					style={!this.state.isStarted ? {backgroundImage: `url(${this.props.imageUrl})`} : {}}
					onClick={() => this.setState({isStarted: true})}
				>
					{this.state.isStarted
						? <ReactPlayer url={this.props.videoUrl} controls={true} width={'100%'} height={'100%'} playing={isPlaying} onPause={() => this.pause()} onPlay={() => this.unpause()}/>
						: <span className="play-btn-overlay"><i className="fa fa-play"></i></span>
					}
				</div>
			</div>
		)
	}
}
